export type PurchaseOrderStatus =
  | 'DRAFT'
  | 'SUBMITTED'
  | 'RECEIVING'
  | 'SHIPPED'
  | 'PENDING_LIQUIDATION'
  | 'CLOSED'
  | 'CANCELLED'
  | 'ERROR';

const Groups: Record<string, PurchaseOrderStatus[]> = {
  // TODO: fill out the rest of the statuses
  toSubmittedOrCancelled: ['DRAFT', 'SUBMITTED', 'CANCELLED'],
  toSubmitted: ['DRAFT', 'SUBMITTED'],
};

export default { Groups };
